<template>
  <div v-if="links && links.admin_show_uri && links.admin_show_uri.href" class="wdw-admin-link">
    <a :href="links.admin_show_uri.href" target="_blank">
      <font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']" aria-hidden="true" />
      In Admin-Backend öffnen
    </a>
  </div>
</template>

<script>
export default {
  name: 'admin-link',
  props: {
    links: {
      type: Object,
      required: 1,
    },
  },
};
</script>
